const rolesDictionary = {
  rolesDictionary: [
    {
      roleCode: "hvdriver",
      name: "Таталт хариуцсан ажилтан",
    },
    {
      roleCode: "collector",
      name: "Таталт хариуцсан ажилтан",
    },
    {
      roleCode: "whpicker",
      name: "Агуулахын нярав",
    },
    {
      roleCode: "whreceiver",
      name: "Агуулахын нярав",
    },
    {
      roleCode: "picker",
      name: "Хүргэлтийн ажилтан",
    },
    {
      roleCode: "sorter",
      name: "Агуулахын нярав",
    },
    {
      roleCode: "dispatcher",
      name: "Хүргэлт хариуцсан ажилтан",
    },
    {
      roleCode: "pdriver",
      name: "Жолооч",
    },
    {
      roleCode: "bhdriver",
      name: "Хаб хоорондын жолооч",
    },
    {
      roleCode: "icofficer",
      name: "Агуулахын нярав",
    },
    {
      roleCode: "Warehouse manager",
      name: "Агуулахын менежер",
    },
    {
      roleCode: "AdManager",
      name: "Борлуулалтын ажилтан",
    },
    {
      roleCode: "WH-Admin",
      name: "Админ",
    },
    {
      roleCode: "admin",
      name: "Админ",
    },
    {
      roleCode: "cabinetmanager",
      name: "Кабинет хариуцсан ажилтан",
    },
    {
      roleCode: "head-operator",
      name: "Оператор",
    },
    {
      roleCode: "logistics",
      name: "Хүргэлт хариуцсан ажилтан",
    },
    {
      roleCode: "operator",
      name: "Оператор",
    },
    {
      roleCode: "sales-head",
      name: "Борлуулалтын ажилтан",
    },
    {
      roleCode: "super",
      name: "Супер админ",
    },
    {
      roleCode: "system",
      name: "Ажилтан",
    },
    {
      roleCode: "merchant-admin",
      name: "Мерчант",
    },
  ],
  orderStatus: [
    { label: "Бүгд", value: "all" },
    // { label: "Баталгаажаагүй", value: "created" },
    { label: "Үүсгэсэн", value: "created" },
    { label: "Баталгаажсан", value: "approved" },
    { label: "Захиалга бүрдсэн", value: "completed" },
    { label: "Хүргэлтэнд гарсан", value: "delivery" },
    { label: "Бараа хүргэгдсэн", value: "delivered" },
    { label: "Цуцалсан", value: "canceled" },
  ],
};

export default rolesDictionary;
